import { render, staticRenderFns } from "./editPersonalDetail.vue?vue&type=template&id=66a1c721"
import script from "./editPersonalDetail.vue?vue&type=script&lang=js"
export * from "./editPersonalDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports